module.exports = __webpack_public_path__ + "img/banner2.f8b30a33.jpg";